import { Box, CircularProgress, Grid2 as Grid, Typography } from '@mui/material'
import Container from '@mui/material/Container'
import { useAtomValue } from 'jotai'
import * as React from 'react'
import { useNavigate } from 'react-router'

import TripCard from '../components/cards/TripCard'
import EmptyStateCard from '../components/common/EmptyStateCard'
import SEOHead from '../components/common/SEOHead'
import { isAdminAtom } from '../domains/auth/AuthSelectors'
import TripService from '../services/TripService'

export default function Trips() {
  const navigate = useNavigate()

  const isAdmin = useAtomValue(isAdminAtom)
  const [trips, setTrips] = React.useState([])
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)

  React.useEffect(() => {
    const fetchTrips = async () => {
      try {
        setLoading(true)
        const data = await TripService.getTrips({})
        setTrips(data)
      } catch (err) {
        console.error('Failed to fetch trips:', err)
        setError(err.message)
      } finally {
        setLoading(false)
      }
    }

    fetchTrips()
  }, [])

  const handleChange = async () => {
    const updatedTrips = await TripService.getTrips({})
    setTrips(updatedTrips)
  }

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '50vh' }}>
        <CircularProgress />
      </Box>
    )
  }

  if (error) {
    return (
      <Box sx={{ p: 2, maxWidth: 1200, mx: 'auto' }}>
        <Typography color="error" variant="h6">
          {error}
        </Typography>
      </Box>
    )
  }

  return (
    <>
      <SEOHead pageName="TRIPS" url="https://bookingonsnow.com/events/trips" />
      <Container maxWidth="100%" sx={{ maxWidth: '1400px' }}>
        <Grid alignItems="center" justifyContent="center" sx={{ my: 4 }}>
          <Typography variant="h4" gutterBottom>
            Upcoming Trips
          </Typography>

          {trips.length > 0 ? (
            <Grid container spacing={3} justifyContent="center" alignItems="top" sx={{ width: '100%' }}>
              {trips.map((trip) => (
                <Grid size={{ xs: 12, sm: 8, md: 8, lg: 4 }} key={trip.resourceId}>
                  <Box>
                    <TripCard trip={trip} mode="card" updateHook={handleChange} deleteHook={handleChange} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : (
            <EmptyStateCard
              title="Group Trips Feature Coming Soon!"
              subtitle={
                isAdmin
                  ? "We're working hard to bring group trips feature to our platform. Stay tuned for updates!"
                  : "Exciting news! Group ski trips feature is in development. Soon you'll be able to join amazing winter adventures with fellow snow enthusiasts!"
              }
              buttonText={isAdmin ? 'Coming Soon' : null}
              onButtonClick={() => navigate('/wip')}
              showButton={false}
              image="https://images.pexels.com/photos/848599/pexels-photo-848599.jpeg"
            />
          )}
        </Grid>
      </Container>
    </>
  )
}
